module.exports = __webpack_public_path__ + "img/arrow-up-light.a144034.svg";